import React from 'react';

export default function AcceptRiskSelectedSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1642 1.35082C10.3059 1.09785 10.2164 0.775945 9.95353 0.6536C8.60216 0.024652 7.08037 -0.158395 5.61052 0.13929C3.96859 0.471825 2.50037 1.38219 1.47249 2.70505C0.444605 4.02791 -0.0747665 5.67554 0.00869183 7.34873C0.0921502 9.02191 0.772904 10.6097 1.92733 11.8237C3.08175 13.0377 4.63327 13.7974 6.30014 13.9649C7.96701 14.1324 9.63868 13.6966 11.0116 12.7365C12.3844 11.7764 13.3675 10.3559 13.7822 8.73273C14.1534 7.27971 14.0471 5.75064 13.4869 4.36935C13.3779 4.10066 13.0609 3.99506 12.8012 4.12385C12.5414 4.25265 12.4376 4.56699 12.543 4.8371C12.9936 5.99188 13.0738 7.26335 12.7648 8.47282C12.4124 9.85248 11.5768 11.06 10.4098 11.876C9.24288 12.6921 7.82196 13.0626 6.40512 12.9202C4.98828 12.7778 3.66948 12.132 2.68823 11.1001C1.70697 10.0682 1.12833 8.71862 1.05739 7.29642C0.986448 5.87421 1.42791 4.47373 2.30161 3.34929C3.17531 2.22486 4.4233 1.45105 5.81894 1.1684C7.04242 0.920608 8.30824 1.06468 9.4389 1.57281C9.70337 1.69167 10.0225 1.60379 10.1642 1.35082Z"
        fill="currentColor"
      />
      <path
        d="M3.71622 6.74395L6.66248 8.74345L13 1"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
